import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {Router,ActivatedRoute} from '@angular/router';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import {FormService} from '../../services/form.service';
import { environment } from '../../../environments/environment.prod';
@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: ['./unsubscribe.component.scss']
})
export class UnsubscribeComponent implements OnInit {

  unSubscribeForm:FormGroup;

  demoSubmitted:boolean=false;

  filterObj:any={};
  spinner:boolean=false;
  unsubghostemailUrl:any;
  searchstring:any;
  thankYou:boolean=false;
  errorMassage:any;

  constructor( private http: HttpClient,private formService:FormService,private activatedRoute: ActivatedRoute,public router:Router,private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.spinner=false;
    this.unsubghostemailUrl = environment.apiURL+'attendees/unsubghostemail';

    this.searchstring=document.URL.split('=')[1];
    
    console.log("searchstring",this.searchstring);
    
    this.unSubscribeForm=this.formBuilder.group(
      {
        email: ['', Validators.compose(
          [Validators.pattern('[a-zA-Z0-9.-_]{1,}@[a-zA-Z0-9.-]{2,}[.]{1}[a-zA-Z]{2,}'), Validators.required])],
        
      })
  }
  get l() { return this.unSubscribeForm.controls; }


  onunSubscribe(){
    
    this.errorMassage='';
    this.demoSubmitted=true;

    if(this.unSubscribeForm.valid){
      this.spinner=true;

        this.filterObj.email = this.unSubscribeForm.value.email;
        this.filterObj.searchstring=this.searchstring
        this.http.post(this.unsubghostemailUrl, this.filterObj)
        .subscribe(response => {
            this.spinner=false;
            console.log(response);
            this.thankYou=true;
    
        }, (err: HttpErrorResponse) => {
         this.spinner=false;
          console.log(err);
          this.errorMassage = err.error.message;
        
      });
    }
  }

  clearError(){

    if(this.errorMassage !=''){
      this.errorMassage='';
    }
      
  }

  

}
